import { Flex, HStack } from "@chakra-ui/layout";
import styled from "styled-components";
import type { Job } from "@models/Job";
import { getHumanReadableCompetences } from "@utils/utils";
import { useOrganisation } from "@api/hooks";

interface Props {
	competences: Job["competence"];
	onClick?: () => any;
}

export const CompetencePills: React.FC<Props> = ({ competences, ...rest }) => {
	const { organisation, isLoading } = useOrganisation();

	if (isLoading) {
		return null;
	}

	return (
		<HStack spacing={"0.25rem"}>
			<Flex w="100%" direction={"column"} gap={"0.25rem"}>
				{(getHumanReadableCompetences(competences, organisation?.competences, true) as string[]).map((str) => {
					return (
						<Styles key={str} {...rest}>
							{str}
						</Styles>
					);
				})}
			</Flex>
		</HStack>
	);
};

const Styles = styled.div`
	display: inline-block;
	border-radius: 15px;
	padding: 4px 10px;
	background: rgba(78, 126, 167, 0.2);
	border: 1px solid #4e7ea7;
	color: black;
	font-size: 14px;
	font-weight: 400;

	${(props) => (props.onClick ? "cursor: pointer" : "")};
`;
